import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ISessionInfo } from '../types/ISessionInfo';

export interface IGetSessionInfoParams {
}

export interface IGetSessionInfoResult extends ISessionInfo {
}

export class GetSessionInfoRequest extends Request<IGetSessionInfoParams, IGetSessionInfoResult> {
  constructor() {
    super('getSessionInfo', {});
  }
}
